<template>
  <!-- FAQs > Centered accordion -->
  <div id="antworten" class="bg-white">
    <div class="mx-auto max-w-7xl px-12 py-12 sm:py-32 lg:py-20 lg:px-8">
      <div class="mx-auto max-w-4xl divide-y divide-gray-900/10">
        <h2 class="text-2xl font-bold leading-10 tracking-tight text-gray-900">
          Schnelle Antworten
        </h2>
        <dl class="mt-10 space-y-6 divide-y divide-gray-900/10">
          <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6" v-slot="{ open }">
            <dt>
              <DisclosureButton class="flex w-full items-start justify-between text-left text-gray-900">
                <span class="text-base font-semibold leading-7">
                  {{ faq.question }}
                </span>
                <span class="ml-6 flex h-7 items-center">
                  <PlusSmallIcon v-if="!open" class="h-6 w-6" aria-hidden="true" />
                  <MinusSmallIcon v-else class="h-6 w-6" aria-hidden="true" />
                </span>
              </DisclosureButton>
            </dt>
            <DisclosurePanel as="dd" class="mt-2 pr-12">
              <p class="text-base leading-7 text-gray-600" v-html="faq.answer" />
            </DisclosurePanel>
          </Disclosure>
        </dl>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Disclosure } from '@headlessui/vue';
import { DisclosureButton } from '@headlessui/vue';
import { DisclosurePanel } from '@headlessui/vue';
import { MinusSmallIcon } from '@heroicons/vue/24/outline';
import { PlusSmallIcon } from '@heroicons/vue/24/outline';

const faqs =
[
  {
    question: "Wie funktioniert das St. Audio Studio genau?",
    answer:
      "Du legst deinen Podcast an und erfährst, mit welchen Growth-Ideen du deine Wachstumsziele erreichst. Das können Reichweite, Ansehen oder die Vermarktbarkeit sein. Wir werten fortlaufend aus, mit welchem Methoden-Mix andere Podcasts in einer ähnlichen Wachstumsphase erfolgreich waren und geben diese Insights an dich weiter.",
  },
  {
    question: "Kann ich das erst einmal ausprobieren?",
    answer:
      "Das kannst du! Nach der Regstrierung startest du in einen 30-tägigen Probemonat für deinen Podcast, in dem du vollen Zugriff auf das St. Audio Studio Pro mit allen interaktiven Funktionen erhältst. Danach geht es völlig automatisch und ohne Verpflichtungen im kostenlosen Studio Basic weiter.",
  },
  {
    question: "Wie viele Podcasts kann ich parallel verwalten?",
    answer:
      "Beliebig viele. Du startest für jeden Podcast mit dem Onboarding und der Auswahl deiner Wachstumsziele. Auf der Startseite vom St. Audio Studio wechselst du mit einem Klick zwischen den von dir betreuten Podcasts. Beachte aber bitte, dass die Abrechnung vom Studio Pro je Podcast geschieht und du ggf. einen höheren Plan buchen musst.",
  },
  {
    question: "Wie viele Methoden gibt es (und wo kommen die her)?",
    answer:
      "Wir haben vor einigen Jahren damit begonnen Reichweitentipps für Podcasts zu sammeln und dieses Wissen für das St. Audio Studio strukturiert aufbereitet. Im Austausch mit weiteren Podcast-Expert*innen ist so nach und nach eine vollständige Übersicht all der Dinge entstanden, die du tun kannst, um mit deinem Podcast zu wachsen. Heute umfasst die Liste 99 Methoden, aber wir arbeiten längst daran noch einmal so viele anzulegen. Durch die Erfolgsauswertung lernt unsere Kompass-KI fortlaufend dazu, wie wirksam einzelne Ideen auf bestimmte Ziele hinwirken.",
  },
  {
    question: "Wie lange muss ich mich binden?",
    answer:
      "Wir bieten dir eine monatliche oder jährliche Kündigungsfrist an – je nach gewähltem Abbuchungszeitraum. Du kannst also immer zum Ende deiner Laufzeit kündigen.",
  },
  {
    question: "Meine Frage wurde noch nicht beantwortet…",
    answer:
      'Dann schaue bitte einmal im <a href="https://staudio.tawk.help/" target="_blank"><u>St. Audio Hilfe-Center</u></a> vorbei, wo wir das Studio ausführlich vorstellen, die Einrichtung erklären und du uns auch eine Nachricht schreiben kannst.',
  },
  // More questions...
];
</script>
